// Sobre qué está trabajando el usuario ahora mismo (3.5, D2).
//
// **La pantalla sale de la ruta; el objeto no.** Comprobado en 3.1 sobre
// `AppRouter.tsx`: de las 18 rutas, una sola lleva identificador. En Agentes,
// Conocimiento y Conversaciones lo que se está mirando se elige **dentro** de
// la pantalla, así que no hay de dónde deducirlo: lo tiene que decir ella.
//
// Es lo que convierte «duplica este agente» en algo que el Brain puede hacer
// sin preguntar cuál.
//
// **Se declara la clave y el identificador, no el objeto.** `agent` y su id,
// nunca el agente entero: mandarle lo que hay en la pantalla es justo lo que
// D2 prohíbe, y lo que él ya sabe consultar con sus herramientas.
//
// El proveedor vive aparte, en `WhereIAmContext.tsx`: un fichero que exporta a
// la vez un componente y funciones rompe la recarga en caliente, y ESLint lo
// para.

import { createContext, useContext, useEffect } from 'react'

/** Lo que el usuario tiene delante: de qué tipo es, y cuál. */
export type Focus = { tipo: string; id: string } | null

export const WhereIAm = createContext<{
  focus: Focus
  declare: (focus: Focus) => void
}>({ focus: null, declare: () => {} })

/** Lo declarado, para quien arma la pregunta al Brain. */
export function useFocus(): Focus {
  return useContext(WhereIAm).focus
}

/**
 * Declarar desde una pantalla qué tiene delante el usuario.
 *
 * **Se retira al salir.** Sin eso, el Brain seguiría creyendo que miras un
 * agente después de irte a Conocimiento, y actuaría sobre él: una respuesta
 * equivocada con toda la confianza del mundo, que es peor que no saber.
 */
export function useDeclareFocus(tipo: string, id: string | null | undefined) {
  const { declare } = useContext(WhereIAm)

  useEffect(() => {
    declare(id ? { tipo, id } : null)
    return () => declare(null)
  }, [declare, tipo, id])
}
